// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__3lo4a","descriptionTitle":"styles_descriptionTitle__36tAg","descriptionText":"styles_descriptionText__FHvbr"};